import { render } from "./AddressList.vue?vue&type=template&id=fd603bf4&scoped=true"
import script from "./AddressList.vue?vue&type=script&lang=js"
export * from "./AddressList.vue?vue&type=script&lang=js"

import "./AddressList.vue?vue&type=style&index=0&id=fd603bf4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd603bf4"],['__file',"src/assets/js/pages/Intercom/AddressList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd603bf4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd603bf4', __exports__)) {
    api.reload('fd603bf4', __exports__)
  }
  
  module.hot.accept("./AddressList.vue?vue&type=template&id=fd603bf4&scoped=true", () => {
    api.rerender('fd603bf4', render)
  })

}


export default __exports__